import {useEffect} from 'react';
import {useDispatch, useSelector, useStore} from 'react-redux';
import {navigateToRoute, useCurrentRoute} from '~/CreateFabricGreetingCard/navigation';
import {UPDATE_DESIGN_OPTIONS} from '~/CreateFabricGreetingCard/reducers/fabricDesign/constants';
import {selectSavingStep} from '~/CreateFabricGreetingCard/reducers/fabricDesign/selectors';
import {Button} from '~library/atoms/Button';
import {LoadingOverlay} from '~library/molecules/LoadingOverlay';
import {ArrowIcon} from '~library/svg/ArrowIcon';

export const NavBottom = ({showBackBtn = true, ctaVariant = 'primary', ...props}) => {
  const currentRoute = useCurrentRoute();
  const store = useStore();
  const dispatch = useDispatch();
  const savingStep = useSelector(selectSavingStep);
  if (currentRoute.hideBottomNav) return null;

  // biome-ignore lint/correctness/useExhaustiveDependencies: deps
  useEffect(() => {
    dispatch({
      type: UPDATE_DESIGN_OPTIONS,
      payload: {savingStep: false},
    });
  }, []);

  return (
    <div className="create-flow__form-nav">
      {currentRoute.meta.showBackButton && showBackBtn && (
        <Button
          className="create-flow__form-nav-back"
          data-qa-id="nav-bottom-previous"
          variant="secondary"
          size="large"
          type="button"
          ariaLabel="Back"
          onClick={async () => {
            dispatch({
              type: UPDATE_DESIGN_OPTIONS,
              payload: {savingStep: true},
            });
            const navigating = await navigateToRoute(currentRoute.previousRoute, store);
            if (!navigating) {
              dispatch({
                type: UPDATE_DESIGN_OPTIONS,
                payload: {savingStep: false},
              });
            }
          }}
        >
          <ArrowIcon direction="left" className="create-flow__form-nav-back-arrow" ratio={0.75} />
        </Button>
      )}
      {props.children
        ? props.children
        : <Button
            className="create-flow__form-nav-next"
            data-qa-id="nav-bottom-next"
            variant={ctaVariant}
            size="large"
            disabled={props.disabled}
            type="button"
            ariaLabel="Next"
            onClick={async () => {
              dispatch({
                type: UPDATE_DESIGN_OPTIONS,
                payload: {savingStep: true},
              });
              const navigating = await navigateToRoute(currentRoute.nextRoute, store);
              if (!navigating) {
                dispatch({
                  type: UPDATE_DESIGN_OPTIONS,
                  payload: {savingStep: false},
                });
              }
            }}
          >
            {props.customNextButtonText || props.children || currentRoute.nextButtonText}
          </Button>}
      <LoadingOverlay loadingMessage="Saving..." show={savingStep} />
    </div>
  );
};
